import {useTodoMutations} from '../../api/todos';
import {toast} from '../../hooks/useToast';
import {addDays, FollowUp} from '../../lib/todos';
import {nowLocal, offsetMinutes, todayLocal} from '../../lib/when';
import {Post} from '../../types';

// "Remind me" chosen on the tell form: once the tell is saved, the follow-up becomes a to-do with
// the tell's plants and place, pointing back at it.
export function useAddFollowUp() {
    const {create} = useTodoMutations();
    return (tell: Post, followUp: FollowUp) =>
        create.mutate(
            {
                text: followUp.text,
                whenLocal: nowLocal(),
                whenOffsetMinutes: offsetMinutes(),
                dueLocal: addDays(todayLocal(), followUp.days),
                plants: tell.plants.map(p => p.label),
                placeId: tell.place?.id ?? null,
                followsId: tell.id,
                tellKind: followUp.tellKind
            },
            {onSuccess: () => toast.success(`${followUp.text}: on your To do list.`), onError: () => toast.problem('The tell saved, but the reminder did not. Add it from the tell.')}
        );
}
